import React from 'react';
import { Link } from 'react-router-dom';
import '../MainServices.css';

const MainServices = () => {
  const services = [
    {
      id: 1,
      title: 'Company Overview',
      description: 'History and vision of Taebong Industrial Technology',
      icon: '🏢',
      link: '/en/company-overview'
    },
    {
      id: 2,
      title: 'Products',
      description: 'Various heat exchanger product lineups',
      icon: '⚙️',
      link: '/en/products'
    },
    {
      id: 3,
      title: 'Certification',
      description: 'International standard certifications and quality assurance',
      icon: '🏆',
      link: '/en/certification-detail'
    },
    {
      id: 4,
      title: 'Delivery Performance',
      description: 'Plant and HVAC system delivery records',
      icon: '🏭',
      link: '/en/delivery-performance'
    },
    {
      id: 5,
      title: 'Customer Support',
      description: 'Professional technical support and services',
      icon: '🔧',
      link: '/en/customer-support'
    },
    {
      id: 6,
      title: 'ESG',
      description: 'Sustainable management and social responsibility',
      icon: '🌱',
      link: '/en/esg'
    }
  ];

  return (
    <section className="main-services" id="main-services">
      <div className="main-services-container">
        <div className="main-services-header">
          <h2 className="main-services-title">Main Services</h2>
          <p className="main-services-subtitle">Comprehensive solutions for industrial heat exchange needs</p>
        </div>
        <div className="main-services-grid">
          {services.map((service) => (
            <Link key={service.id} to={service.link} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainServices;
